<template>
  <v-list>
    <v-subheader>{{ $t(config.title).toUpperCase() }}</v-subheader>
    <v-list-item v-for="(item, ind) in config.moduleLinkList" :key="ind">
      <v-list-item-icon>
        <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
        <inno-icon v-if="item.innoIcon" :name="item.innoIcon"></inno-icon>
      </v-list-item-icon>
      <v-list-item-content style="white-space: pre-line">
        <v-list-item-subtitle>{{ $t(item.title) }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import InnoIcon from '@/components/icons/InnoIcon';
export default {
  name: 'ModuleLinkList',
  props: {
    config: {
      type: Object,
    },
  },

  components: {
    InnoIcon,
  },
};
</script>
